import { useContext, useEffect } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { emptyCarsFilter, setPage } from "redux/actions"
import { RentingContext } from "scenes/RentingScene/RentingContext"

const mapStateToProps = ({ carsReducer: { page } }) => ({ filterPage: page })

function useFilterPage(hasFilter) {
  const { page } = useContext(RentingContext)
  const { filterPage } = useSelector(mapStateToProps, shallowEqual)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!hasFilter) return

    if (filterPage && filterPage !== page) {
      dispatch(emptyCarsFilter())
      dispatch(setPage(page))
    } else if (!filterPage) {
      dispatch(setPage(page))
    }
  }, [dispatch, filterPage, hasFilter, page])
}

export default useFilterPage
